export interface BuffTypeDef {
  id: string;
  name: string;
  desc: string;
  icon: string;
  multCpS: number;
  multClick: number;
  add: number;
}

export const BUFF_TYPES: BuffTypeDef[] = [
  { id: 'frenzy', name: 'Frenzy', desc: 'Cookie production x7 for 77 seconds!', icon: '🔥', multCpS: 7, multClick: 1, add: 0 },
  { id: 'elder_frenzy', name: 'Elder frenzy', desc: 'Cookie production x666 for 6 seconds!', icon: '👹', multCpS: 666, multClick: 1, add: 0 },
  { id: 'click_frenzy', name: 'Click frenzy', desc: 'Clicking power x777 for 13 seconds!', icon: '⚡', multCpS: 1, multClick: 777, add: 0 },
  { id: 'dragonflight', name: 'Dragonflight', desc: 'Clicking power x1111 for 10 seconds!', icon: '🐉', multCpS: 1, multClick: 1111, add: 0 },
  { id: 'cookie_storm', name: 'Cookie storm', desc: 'Cookies rain from the sky!', icon: '🌧️', multCpS: 1, multClick: 1, add: 0 },
  { id: 'building_special', name: 'Building special', desc: '+10% CpS for 30 seconds!', icon: '🏗️', multCpS: 1.1, multClick: 1, add: 0 },
  { id: 'clot', name: 'Clot', desc: 'Cookie production halved for 66 seconds.', icon: '🩸', multCpS: 0.5, multClick: 1, add: 0 },
  { id: 'cursed_finger', name: 'Cursed finger', desc: 'Cookie production halted, but clicks are worth a lot for 10 seconds.', icon: '☠️', multCpS: 0, multClick: 1, add: 0 },
];
